import { GridCustomCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { formatPrice } from '../../../../../../common/global/helpers';
import { GridCellTd } from '../../../../../../common/widgets/Grid';
import Icons from '../../../../../../common/widgets/Icons';
import { config } from '../../../../config';
import { resources } from '../../../../resources/resources';

export const OrderIdCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return <GridCellTd>{dataItem.orderId}</GridCellTd>;
};

export const StateCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return (
    <GridCellTd>
      <span
        className="grid-status-badge"
        style={{
          color: dataItem.stateFgColor,
          backgroundColor: dataItem.stateBgColor,
        }}
      >
        {dataItem.state}
      </span>
    </GridCellTd>
  );
};

export const ViewDetailsCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  return (
    <GridCellTd className="grid-actions-cell">
      {dataItem.orderId != 0 && (
        <span className="grid-actions">
          <button
            className="btn-link grid-action-nav"
            onClick={() => navigate(`${dataItem.orderId}`)}
          >
            <span className="btn-icon">
              <Icons.ArrowButton />
            </span>
            <span className="btn-text">
              {translate(resources.admin.employees.grid.actions.viewDetails)}
            </span>
          </button>
        </span>
      )}
    </GridCellTd>
  );
};

export const ProductsCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return (
    <GridCellTd>
      <ul style={{ listStyleType: 'none', marginLeft: -30 }}>
        {dataItem.productNames.map((pn: string, index: number) => (
          <li key={`${dataItem.orderId}-${index}-${pn}`}>{pn}</li>
        ))}
      </ul>
    </GridCellTd>
  );
};
export const EmployeeCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return (
    <GridCellTd>
      <strong>{dataItem.employee}</strong>
    </GridCellTd>
  );
};
export const TotalCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return (
    <GridCellTd className="grid-number">
      {`${formatPrice(dataItem.total)} ${config.currency}`}
    </GridCellTd>
  );
};
export const DateAddedCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return (
    <GridCellTd>
      {dataItem.dateAdded
        ? moment(new Date(dataItem.dateAdded)).format('DD.MM.YYYY')
        : ''}
    </GridCellTd>
  );
};
